export default "__VITE_ASSET__BU_RHjR1__"